import './App.css';
import { useState, useEffect, useRef, useCallback } from 'react';
import Navbar from './components/navbar';
import Content from './components/content';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ReactGA from 'react-ga4';

// Debounce utility function
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

// Environment variable validation
const validateEnvVars = () => {
  const requiredEnvVars = [
    'REACT_APP_EMAILJS_SERVICE_ID',
    'REACT_APP_EMAILJS_TEMPLATE_ID',
    'REACT_APP_EMAILJS_PUBLIC_KEY',
    'REACT_APP_RECAPTCHA_SITE_KEY',
  ];

  const missingVars = requiredEnvVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0) {
    console.warn('Missing environment variables:', missingVars);
    console.warn('Some features may not work properly. Please check your .env file.');
  }
};

const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const contentRef = useRef(null); // Ref scrollattavalle sisältöelementille
  const lastScrollTop = useRef(0);

  const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-GC0F1TVYYJ';
  
  useEffect(() => {
    // Validate environment variables on app startup
    validateEnvVars();
    
    if (TRACKING_ID) {
      ReactGA.initialize(TRACKING_ID);
    }
  }, []);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMobile(window.innerWidth < 768);
    }, 150);
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isMobile) {
      return;
    }
    setIsOpen(true);
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (!navbar) {
        console.error('Navbar element not found');
        return;
      }
      const scrollTop = contentRef.current.scrollTop;
      if (scrollTop > lastScrollTop.current) {
        navbar.classList.add('navbar-hide');
      } else {
        setIsOpen(true);
        navbar.classList.remove('navbar-hide');
      }
      lastScrollTop.current = scrollTop;
    };

    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (contentElement) {
        contentElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isMobile]);
  return (
    <div className="relative flex h-screen overflow-hidden">
      <div className={`absolute md:static top-0 left-0 w-full md:w-64 ${isOpen ? 'block' : 'hidden'} md:block`}>
        <Navbar toggleNavbar={toggleNavbar} isMobile={isMobile} />
      </div>
      <div
        ref={contentRef}
        className={`flex-1 overflow-auto hide-scrollbar ${!isMobile ? 'snap-y snap-mandatory' : ''}`}
      >
        <div className="h-full">
          <Content isMobile={isMobile} />
        </div>
      </div>
    </div>
  );
};

export default App;
